import React from "react";
import Images from "../../Component/Simage";

function Protocols() {
  return (
    <div className="container ai-container">
      <div className="protocols">
        <p className="title fw-500 mb-0 text-center">Protocols</p>

        <div className="cus_card">
         <div className="item">
            <p className="mb-0 value fw-700">SDK</p>
         </div>
         <div className="item">
            <p className="mb-0 value fw-700">API</p>
         </div>
         <div className="item">
            <p className="mb-0 value fw-700">Docs</p>
         </div>
        </div>
      </div>
    </div>
  );
}

export default Protocols;
